module.exports = "hello\r\nhi"